module.exports = __webpack_public_path__ + "static/img/西数模块.5c976f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product_images/西数模块.png
// module id = KJ6h
// module chunks = 1